module.exports = __webpack_public_path__ + "img/11-install-step-6-optional.2530522f.webp";